module.exports = __webpack_public_path__ + "img/completed-review.5ec80c6a.png";